import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SelectQuestionGroup } from "../../../checklist.interface";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-select-question-group-element",
	templateUrl: "./select-question-group-element.component.html",
	styleUrls: ["./select-question-group-element.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectQuestionGroupComponent {
	constructor(private rideOpsUi: RideOpsUiService) {}

	@Input() element: SelectQuestionGroup;

	isV2 = (): boolean => this.rideOpsUi.isV2Active();
}
